const icon = require('vue-svgicon');
icon.register({
    'caret-bottom': {
        width: 1024,
        height: 1024,
        viewBox: '0 0 1024 1024',
        data: `<path pid="0" d="M27.928 322.908l37.236-37.236L512 737.162l446.836-451.49 37.236 37.236L512 802.326z"/>`,
    },
});
